import { selectIsUserAgent } from './selectIsUserAgent';
import { IAppState } from '../../../../shared/common/state';

export const selectIsProfessionalSearchPromoVisible = (state: IAppState) => {
  const isAgent = selectIsUserAgent(state);

  return isAgent;
};
